import { CACHE_VERSION } from './cacheConfig';

export const getFromLocalStorage = (key) => {
	try {
		const item = JSON.parse(localStorage.getItem(key));
		if (!item) return null;

		const currentTime = new Date().getTime();
		if (currentTime > item.expiry || item?.version !== CACHE_VERSION) {
			localStorage.removeItem(key);
			return null;
		}

		return item.data;
	} catch (error) {
		console.error("Error getting from localStorage", error);
		return null;
	}
};

export const saveToLocalStorage = (key, data) => {
	const TTL = 3 * 24 * 60 * 60 * 1000; // 3 days
	try {
		let updatedData = data
		const existingItem = JSON.parse(localStorage.getItem(key)) || {};
		const existingData = existingItem.data || {};
		const expiryTime = new Date().getTime() + TTL;

		if (key !== 'menuData') {
			updatedData = {
				...existingData,
				...data,
				sections: {
					...existingData.sections,
					...data.sections
				},
				media: {
					...existingData.media,
					...data.media
				}
			};
		}

		const dataToStore = {
			data: updatedData,
			expiry: expiryTime,
			version: CACHE_VERSION
		};

		localStorage.setItem(key, JSON.stringify(dataToStore));
	} catch (error) {
		console.error("Error saving to localStorage", error);
	}
};
